import React, {useState, useEffect, useContext} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {TREE_SELECTOR_TREE_TYPE_SPACE_TYPE} from "../constants/general-constants";
import {TREE_SELECTOR_TREE_TYPE_CLASSIFICATION_ITEM} from "../constants/general-constants";
import {TREE_SELECTOR_TREE_DASHBOARD_SPACE_TYPE} from "../constants/general-constants";
import {TREE_SELECTOR_TREE_DASHBOARD_CLASSIFICATION_ITEM} from "../constants/general-constants";
import ChildSelector from "../components/TreeSelector";
import {functions} from "../constants/common-functions";

export default function TreeSelector({

    depth,
    id,
    dashboardId,
    treeType,
    label,
    setFunction,
    inputId,

    facilityId,
    floorId,
    spaceId,
    spaceTypeId,
    classificationId,
    classificationItemId,

    childLabel,

    filterBean

}){
	const [displayDropDown, setDisplayDropDown] = useState(false);
	const [selectOptions, setSelectOptions] = useState([]);
	const [childDisplay, setChildDisplay] = useState('');
	const [thisId, setThisId] = useState(inputId);
	
	
	useEffect(() => {

	    const thisFilterBean = {

	        ...filterBean,
	        parentId: inputId
	    };

	    if(treeType === TREE_SELECTOR_TREE_TYPE_SPACE_TYPE){

	        functions.postFilterBeanAjax(

	            "/resolutionsoftwareplatform/spacegetspacetypes?parentId=" + inputId,
	            thisFilterBean,
	            populateOptions

	        );

	    }
	    else{

	        functions.postFilterBeanAjax(

	            "/resolutionsoftwareplatform/spacegetclassificationitems?parentId=" + inputId,
	            thisFilterBean,
	            populateOptions

	        );

	    }

	}, [

	    dashboardId,
	    inputId,
	    filterBean

	]);
	
	const populateOptions = (results) => {
		let tempSelectOptions = [];
		for(let i=0; i<results.length; i++){
			tempSelectOptions.push({
				id:results[i].id,
				code:results[i].code,
				name:results[i].name
			});
		}
		setSelectOptions(tempSelectOptions);
	};
	
	const thisContainer = {
		display:"flex",
		width:"100%",
		alignItems:"center",
		flexDirection:"column"
	};
	
	const primaryContainer = {
		display:"flex",
		width:"100%",
		alignItems:"center",
		minHeight:"40px",
	};
	
	const treeSelectorRow = {
		display:"flex",
		height:"40px",
		alignItems:"center"
	};
	
	const treeSelectorLabel = {
		display:'flex',
 		width:"140px",
 		color:"white",
 		fontSize:'12px',
 		fontWeight:"bold",
 		marginLeft:"20px"
	};
	
	const treeSelectorSelect = {
 		display:'flex',
 		width:"275px",
 		height:"30px",
 		border:"1px solid lightgrey",
 		borderRadius:"5px",
 		paddingLeft:"10px",
 		fontSize:'12px',
 		color:"white",
 		backgroundColor:"rgba(0,0,0,0)"
	};
	
	const childContainer = {
		display:'flex',
		width:"100%",
		flexDirection:"column"
	};
	
	const selectOptionsDisplay = selectOptions.map((item, index) => 
		<option value={item.id} style={{color:'black'}}>
			{item.name}
		</option>
	);
	
	const handleChildSelect = (id) => {
	
		if(id != "-100"){
			setFunction(id);	
		}
		else{
			setFunction(thisId);
			setChildDisplay('');
		}
	}
	
	const handleChange = (e) => {
		let selectedId = e.target.value;
		setThisId(selectedId);
		setFunction(selectedId);
		if(selectedId != "-100"){
				
				if(parseInt(depth) === 0){
					setChildDisplay(<TreeSelector
						id={id + 1}
						dashboardId={dashboardId} 
						treeType={treeType} 
						label={childLabel}
						setFunction={handleChildSelect} 
						inputId={selectedId}
						facilityId={facilityId}
						floorId={floorId}
						spaceId={spaceId}
						spaceTypeId={spaceTypeId} 
						classificationId={classificationId}
						classificationItemId={classificationItemId}
						childLabel=""
						depth={depth + 1}
					/>);
				}
		}
		else{
			setThisId(inputId);
			setChildDisplay('');
		}
	};
	
	return (
		<div style={thisContainer}>
			<div style={primaryContainer}>
				<div style={treeSelectorLabel}>
					{label}
				</div>
				<select style={treeSelectorSelect} onChange={handleChange}>
					<option value="-100">
						Select
					</option>
					{selectOptionsDisplay}
				</select>
			</div>
			<div style={childContainer}>
				{childDisplay}
			</div>
		</div>
	);
}